import { render, staticRenderFns } from "./SenderDetails.vue?vue&type=template&id=fc0059ce&"
import script from "./SenderDetails.vue?vue&type=script&lang=js&"
export * from "./SenderDetails.vue?vue&type=script&lang=js&"
import style0 from "./SenderDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports